import * as Accordion from "@radix-ui/react-accordion";
import { FC, ReactElement, useEffect } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/router";
import { SideBarLinkProps } from "./SidebarLink";

interface Props {
    Icon?:
        | React.ForwardRefExoticComponent<
              Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
                  title?: string | undefined;
                  titleId?: string | undefined;
              } & React.RefAttributes<SVGSVGElement>
          >
        | (({ className }: { className: string }) => ReactElement);
    children: ReactElement<SideBarLinkProps>[];
    label: string;
    handleOpenLabelChange: (label: string) => void;
}

const SidebarGroup: FC<Props> = ({
    label,
    Icon,
    children,
    handleOpenLabelChange,
}) => {
    const router = useRouter();
    const isActive = children.some(
        (child) => child.props.location === router.pathname,
    );

    useEffect(() => {
        if (isActive) {
            handleOpenLabelChange(label);
        }
    }, [isActive, handleOpenLabelChange, label]);

    return (
        <Accordion.Item
            className="group overflow-hidden rounded-lg data-[state=open]:bg-secondary-gray-3/5"
            value={label}
        >
            <Accordion.Header asChild>
                <Accordion.Trigger asChild>
                    <button type="button" className="group/bunch w-full">
                        <div className="mb-1 flex w-full items-center justify-between px-4 py-2.5 transition-all hover:bg-secondary-gray-2">
                            <div className="flex gap-4">
                                {Icon ? (
                                    <Icon
                                        className={`size-6 stroke-0 group-hover/bunch:animate-wiggle ${isActive ? "text-primary" : ""}`}
                                    />
                                ) : null}
                                <span className="">{label}</span>
                            </div>
                            <ChevronRightIcon
                                className="size-3 stroke-3 duration-300 group-data-[state=open]:rotate-90"
                                aria-hidden
                            />
                        </div>
                    </button>
                </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content className="flex flex-col gap-1 pb-4 data-[state=closed]:animate-menu-close data-[state=open]:animate-menu-open">
                {children}
            </Accordion.Content>
        </Accordion.Item>
    );
};

export default SidebarGroup;
